import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Input, Select, message, Checkbox, Typography, Button, List, InputNumber, Row, Col, Card } from 'antd';
import 'moment/locale/ru';
import { createUseStyles } from 'react-jss'
import { POST, errorCatch, errorAlert, deleteInArray, GET } from '../Tool'
import Icofont from 'react-icofont';
import Collection from '../Collection'

const useStyles = createUseStyles({
    promo: {
        '& .a': {
            padding: "0px",
        },
    },
})

export default function AbstractCollection(props) {
    const { auth, name, detail, filter, columns, filters, form, meta, options, source, collectionActions, modelActions, noPagination } = props;
    var xdetail = detail;
    var xfilter = filter;
    if (!xdetail) xdetail = 'none';
    xfilter = (!xfilter) ? '' : '&' + xfilter;
    return (
        <Collection
            auth={auth}
            noPrint={true}
            noPagination={(noPagination !== undefined)?noPagination:false}
            size="small"
            source={source || ("/api/query/" + name.toLowerCase() + "?detail=" + xdetail + xfilter)}
            columns={columns}
            filters={filters}
            collectionActions={collectionActions || (() => [
                {
                    title: "Создать",
                    action: {
                        method: "POST",
                        path: "/api/query-create/" + name.toLowerCase(),
                        mutation: "update",
                        onValues: (values, context) => {
                            return { ...values }
                        },
                        onClose: ({ unlock, close }, context) => close(),
                    },
                    form: form,
                    options: { 
                        initialValues: {},
                        ...options 
                    },
                    meta: meta,
                }
            ])}
            modelActions={modelActions || ((item, index) => [
                {
                    title: "Изменить",
                    action: {
                        method: "POST",
                        path: "/api/query-update/" + name.toLowerCase(),
                        mutation: "update",
                        onValues: (values, context) => {
                            return { ...values, ID: item.ID }
                        },
                        onClose: ({ unlock, close }, context) => close()
                    },
                    form: form,
                    options: { 
                        initialValues: {
                            ...item
                        },
                        ...options 
                    },
                    meta: meta,
                    object: item,
                },
                {
                    title: "Удалить",
                    action: (values, unlock, close, { collection, setCollection }) => {
                        GET(auth, "/api/query-delete/" + name.toLowerCase() + '/' + item.ID,
                            () => setCollection(deleteInArray(collection, item)), errorCatch
                        );
                        // POST(auth, "/api/query-delete/" + name.toLowerCase(), { ...item },
                        //     () => setCollection(deleteInArray(collection, item)), errorCatch
                        // );
                    },
                }
            ])}
        />
    );
};